import { useQuery } from "@tanstack/react-query";
import {
  fetchInternalExperiences,
  FetchInternalExperiencesParams,
  InternalExperiencesResponse
} from "PFCore/services/internal_experiences";
import { QueryOptions } from "PFTypes";

import { internalExperiencesKeys } from "./query_keys";

export const useInternalExperiences = (
  params: FetchInternalExperiencesParams,
  options: QueryOptions<InternalExperiencesResponse> = {}
) =>
  useQuery<InternalExperiencesResponse>({
    queryKey: internalExperiencesKeys.list(params),
    queryFn: () => fetchInternalExperiences(params),
    ...options
  });
